// GENERATED CODE - DO NOT EDIT
export const KeyDateTypeMap = {
    // "reduced" dates are dates on which we are open, but have reduced hours.
    REDUCED: 'reduced',
    // "holiday" dates are dates on which we are closed for business.
    HOLIDAY: 'holiday',
    // dates on which scheduling is blocked due to an emergency.
    EMERGENCY_CLOSURE: 'emergency_closure',
    // dates on which self-scheduling by patients is blocked due to an emergency.
    EMERGENCY_CLOSURE_PATIENT_ONLY: 'emergency_closure_patient_only',
};
//# sourceMappingURL=types.js.map